export const RIDDLES = [
  {
    question:
      "I'm a vessel on your roof, you'll find me there, Collecting rainwater, it's only fair. What am I, helping plants and saving water too, An eco-friendly element, can you guess who?",
    answers: ["rain barrel"],
  },
  {
    question:
      "I'm a light that's different, in every way, Using less energy both night and day. What am I, shining brightly with a modern twist, An eco-friendly bulb, energy-efficient bliss?",
    answers: ["led bulb"],
  },
  {
    question:
      "I'm a garden's best friend, green and true, Converting food scraps into something new. What am I, with microorganisms at play, An eco-friendly bin, both night and day?",
    answers: ["compost bin"],
  },
  {
    question:
      "I'm a roof's secret, harnessing the sun's power, Creating electricity, hour by hour. What am I, on sunny days, I'm all the rage, An eco-friendly panel, reducing your energy wage?",
    answers: ["solar panel"],
  },
  {
    question:
      "I'm a device in your hand, guiding your way, Reducing paper clutter every single day. What am I, with digital pages to replace, An eco-friendly reader in a compact, modern case?",
    answers: ["e-reader", "ereader", "e reader", "electronic reader"],
  },
  {
    question:
      "I'm a timer in your garden, controlling the flow, Of water to your plants, so they can grow. What am I, conserving water's embrace, An eco-friendly device in your garden space?",
    answers: ["irrigation timer"],
  },
  {
    question:
      "I'm a vehicle without an engine's sound, Taking you places in your local town. What am I, with pedals and eco-friendly might, A two-wheeled wonder, it's quite a sight?",
    answers: ["bicycle"],
  },
  {
    question:
      "I'm a container for your dreams and thoughts, Filled with stories and wisdom, lessons taught. What am I, with pages and a cover's case, A source of knowledge, in a reading space?",
    answers: ["book"],
  },
  {
    question:
      "I'm green and leafy, but I don't walk or run, In a pot or a planter, I catch the sun. I purify the air, make a room feel alive, In homes and offices, it's me you'll often find. What am I that brings nature inside, With oxygen and beauty, I can't hide?",
    answers: ["houseplant"],
  },
  {
    question:
      "I'm a haven for your rest, sturdy and wide, Where you lay your head and close your eyes. What am I, with pillows and a cozy case, Your nighttime retreat in a bedroom's space?",
    answers: ["bed"],
  },
];

export const POINTS_PER_RIDDLE = 10;

export function shuffleIds(length) {
  const ids = Array.from({ length }, (_, i) => i);
  for (let i = ids.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [ids[i], ids[j]] = [ids[j], ids[i]];
  }
  return ids;
}

export function checkRiddleAnswer(value, answers) {
  const userInput = String(value || "").trim().toLowerCase();
  if (!userInput) return false;
  return answers.some((a) => userInput === String(a).toLowerCase());
}
